/**
 * Antifraud frontend API
 * Antifraud frontend API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum FraudReportType {
    NBRK_PAYMENT_FRAUD = 'NBRK_PAYMENT_FRAUD',
    ARDFM_LOAN_FRAUD = 'ARDFM_LOAN_FRAUD',
    CPSA_PAYMENT_FRAUD = 'CPSA_PAYMENT_FRAUD',
    CPSA_LOAN_FRAUD = 'CPSA_LOAN_FRAUD'
}

